export var defaultProps = {
    className: '',
    defaultValue: '',
    value: '',
    disabledItems: [],
    range: [],
    fullscreen: true,
    mode: 'month',
    onChoose: function (value) { },
    onChange: function (value) { },
    onPanelChange: function (value, mode) { },
};
